import setState from '../utils/storeUtils';
import createPrice from '../../../common/models/priceModel';
import { isObject } from '../../../common/utils/type';

/**
 * @typedef productGiftCardState
 * @type {Object}
 * @property {Boolean} amountError -
 * @property {Boolean} loading -
 * @property {Object|null} product full product info
 * @property {Object|null} selectedCardAmount -
 * @property {Object|null} selectedCardOption -
 */
const initialState = {
  amountError: false,
  loading: false,
  product: null,
  selectedCardAmount: null,
  selectedCardOption: null,
};

export const types = {
  load: 'productGiftCard/load',
  loading: 'productGiftCard/loading',
  reset: 'productGiftCard/reset',
  setSelectedCardAmount: 'productGiftCard/setSelectedCardAmount',
  setSelectedCardOption: 'productGiftCard/setSelectedCardOption',
};

export const getters = {
  allowCustomAmount: 'productGiftCard/allowCustomAmount',
  allowScheduledDelivery: 'productGiftCard/allowScheduledDelivery',
  cardOptions: 'productGiftCard/cardOptions',
  form: 'productGiftCard/form',
  predefinedAmounts: 'productGiftCard/predefinedAmounts',
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    allowCustomAmount: (state) => !!state.product?.allowCustomAmount,
    allowScheduledDelivery: (state) => !!state.product?.allowScheduledDelivery,
    cardOptions: (state) => state.product?.cardsOptions || [],
    form: (state) => state.product?.giftCardForm || {},
    predefinedAmounts: (state) => state.product?.predefinedAmounts || [],
  },
  mutations: {
    loading: setState('loading'),
    setProduct: setState('product'),
    setSelectedCardAmount(state, cardAmount) {
      const { minValue, maxValue } =
        state.product?.giftCardForm?.cardAmount || {};
      const currentAmount = isObject(cardAmount)
        ? cardAmount
        : createPrice(cardAmount || 0);
      const isValid =
        !!currentAmount.value &&
        (!minValue || minValue <= currentAmount.value) &&
        (!maxValue || maxValue >= currentAmount.value);

      state.amountError = !isValid;
      state.selectedCardAmount = isValid ? currentAmount : null;
    },
    setSelectedCardOption: setState('selectedCardOption'),
  },
  actions: {
    load({ commit }, product) {
      commit('loading', true);
      commit('setProduct', product);
      const initialCardOption = product?.cardsOptions?.[0];
      if (initialCardOption) commit('setSelectedCardOption', initialCardOption);
      commit('loading', false);
    },
    reset({ commit, state }) {
      const { product } = state;
      commit('setSelectedCardAmount', null);
      const initialCardOption = product?.cardsOptions?.[0];
      if (initialCardOption) commit('setSelectedCardOption', initialCardOption);
    },
  },
};
